import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import News from '@/views/News.vue'
import NewsList from '@/components/NewsList.vue'
import NewsElement from '@/components/NewsElement.vue'
import vueScrollTo from 'vue-scrollto'


Vue.use(VueRouter)
Vue.use(vueScrollTo)


const routes = [
  { path: '/', name: 'Home', component: Home},
  { path: '/vaillant', name: 'Vaillant', component: () => import('../views/Vaillant.vue') },
  { path: '/brotje', name: 'Brotje', component: () => import('../views/Brotje.vue') },
  { path: '/polityka-cookies', name: 'Cookies', component: () => import('../views/Cookies.vue') },
  { path: '/polityka-prywatnosci', name: 'Privacy', component: () => import('../views/Privacy.vue') },
  {
    path: '/news/', 
    name: 'News', 
    component: News,
    children: [
      {
        path: '',
        component: NewsList,
      },
      {
        path: ':slug',
        component: NewsElement
      },
    ]
  },
  { path: '*', redirect: { name: 'Home' }}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
